<mat-accordion>
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title> Toolchains for Scenario Assessments </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-panel-description>
      <a href="https://citiwatts.github.io/wiki/learning-toolchain-approach/">
        <button matIconButton aria-label="Wiki" matTooltip="Wiki">
          <mat-icon class="blue-icon">help</mat-icon>
        </button>
        Learn about the Toolchaining concept
      </a>
    </mat-panel-description>
    <div class="toolchain-scenarios-list">
      @for (cm of toolchainScenarios; track $index) {
        <div class="toolchain-scenarios">
          {{ cm.name }}
          <div class="buttons">
            <a href="{{ cm.wiki_url }}" target="_blank">
              <button matIconButton aria-label="Wiki" matTooltip="Wiki">
                <mat-icon>menu_book</mat-icon>
              </button>
            </a>
            <a href="{{ cm.download_url }}" target="_blank">
              <button matIconButton aria-label="Download" matTooltip="Download file">
                <mat-icon>download</mat-icon>
              </button>
            </a>
          </div>
        </div>
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>
